export function formatDistanceKm(km) {
  if (km == null || Number.isNaN(Number(km))) {
    return null;
  }

  const value = Number(km);

  if (value > 9) {
    return '9+ km';
  }

  return `${value.toFixed(1).replace('.', ',')} km`;
}

export function formatProviderDeliveryLine(distanceKm) {
  const distanceLabel = formatDistanceKm(distanceKm);
  const prefix = distanceLabel ? `${distanceLabel} \u2022 ` : '';

  return `${prefix}Entrega em até 24h \u2022 R$10,00`;
}
